import {createAction} from 'redux-actions'

export const setLoading = createAction('CENTRAL_STATIONS/LICENSE/SET_LOADING', (isLoading) => ({isLoading}))
export const fetchCanAdd = createAction('CENTRAL_STATIONS/LICENSE/ADD/FETCH')
export const receiveCanAdd = createAction('CENTRAL_STATIONS/LICENSE/ADD/RECIEVE')